import React, {useEffect, useState} from "react";
import {Col, Row} from "react-bootstrap";
import MachineSelectionSection from "./MachineSelectionSection";
import ConfiguredMachineModelsTable from "./ConfiguredMachineModelsTable";
import MachineConfiguration from "./MachineConfiguration";
import {hasFontManagementFullAccess} from "../../helpers/jwt";
import MachineModelSelectionSection from "./MachineModelSelectionSection";

const MachineStep = ({format, setLoader, reload, setReload}) => {


    const [readMode, setReadMode] = useState(false);


    const [selectedMachineModel, setSelectedMachineModel] = useState();
    const onConfigurationFinished = () => {
        setSelectedMachineModel(undefined)
        setReload(!reload)
    }
    useEffect(() => {
        if (format) {
            let result = format.formatStatus && format.formatStatus !== "CONFIGURATION";

            if (!result && selectedMachineModel) {
                result = format.machineModels.some(m => m.id === selectedMachineModel.id)
            }

            setReadMode(result)
        }
    }, [format, selectedMachineModel])

    return (
        <>
            {format && format.machineTypes &&
                <Row className={"mt-2"}>
                    {!selectedMachineModel &&
                        <>
                            {!readMode &&
                                <Col md={5}>
                                    <MachineModelSelectionSection
                                        format={format}
                                        setLoader={setLoader}
                                        setSelectedMachineModel={setSelectedMachineModel}
                                        reload={reload}
                                        access={hasFontManagementFullAccess()}
                                    />
                                </Col>
                            }
                            <Col md={!readMode?7:12}>
                                <ConfiguredMachineModelsTable
                                    format={format}
                                    setLoader={setLoader}
                                    reload={reload}
                                    readOnly={readMode}
                                    setSelectedMachineModel={setSelectedMachineModel}
                                />
                            </Col>
                        </>
                    }
                    {
                        selectedMachineModel &&
                        <MachineConfiguration
                            format={format}
                            machineModel={selectedMachineModel}
                            setLoader={setLoader}
                            checkAllByDefault={true}
                            readOnly={readMode}
                            reload={reload}
                            onConfigurationFinished={onConfigurationFinished}
                        />
                    }

                </Row>
            }
        </>

    );
};


export default MachineStep;